export class RevisionData {
    id: string;
    name: string;
    creatorId: string;
    authorsIds: string[];
    diffData: {
      main: {
        insertions: string;
        deletions: string;
      };
    };
    createdAt: Date= new Date();
    attributes: {};
    fromVersion: number;
    toVersion: number;

    constructor(){
        this.id="";
        this.name= "";
        this.creatorId= "";
        this.authorsIds=[];
        this.diffData={main: {insertions: "", deletions: ""}};
        this.createdAt= new Date()
        this.attributes= {};
        this.fromVersion= 0;
        this.toVersion=0;
    }
   
  }
  // export interface AppData {

  //   userId: string;

  //   users: {

  //     id: string;

  //     name: string;

  //     avatar?: string;

  //   }[];

  //   suggestions: any[];

  //   comments: any[];

  // };
  // export class AppData {
  //   data: string;
  //   user: {
  //     id: string;
  //     name: string;
  //   };
  //   userId: string;
  //   constructor(){
  //     this.data= ``,
	//     this.user= {
	// 	    id: 'u1',
	// 	    name: 'Mex Haddox'
	//     },
	//     this.userId= 'u1'
  //   }
  // }
  // export class ckData {
  //   data: string;
  //   comment: any;
  //   revisionHistory: any;
  //   trackChanges: any;
  //   constructor(){
  //     this.data= '',
  //     this.comment= null,
  //     this.revisionHistory= null,
  //     this.trackChanges= null
  //   }
  // }
  export enum revisionHistoryAccessTypeEnum {
    All = 0,
    CommentOnly = 2,
    Readonly = 1,
  }
  export class AppDataWithoutRevision {
    data: string;
    user: {
      id: string;
      name: string;
    };
    userId: string;
    noteId:string;
    constructor(){
      this.data= ``,
	    this.user= {
		    id: 'u1',
		    name: 'Mex Haddox'
	    },
	    this.userId= 'u1'
      this.noteId = '5'
    }
  }
   export class AppData {
    data: string;
    users: [{
      id: string;
      name: string;
    },
  {
    id: string;
    name: string;
  }];
    userId: string;
    noteId:string;
    constructor(){
      this.data= `Hello world`,
	    this.users= [
        {
		    id: 'u1',
		    name: 'Joginder'
	    },{
        id: 'u2',
		    name: 'Ankush'
      }
    ],
	    this.userId= 'u1',
      this.noteId = '5'
    }
  }


  interface UserComment {
    mainComment: [];
    replies:[];
}


  export class CkData {
    constructor(
      public data: string,
      public comments: any[], // You can replace 'any[]' with a more specific type if needed
      public revisionData: any[], // You can replace 'any[]' with a more specific type if needed
      public trackChangesData: any[] // You can replace 'any[]' with a more specific type if needed
    ) {}
  }
  export enum selfAssessmentTemp2CkEditorTypeEnum {
    assessmentDetails = 0,
    interpretationDetails = 1,
  }
  export class ckUses{
    id: string;
    name: string;
    constructor(){
      this.id="",
      this.name=""
    }
  }